import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { txt } from 'libs/i18n';
import { Tooltip } from 'antd';
import { EditOutlined, MinusOutlined, PlusOutlined, CheckCircleOutlined, } from '@ant-design/icons';
import styles from './style.module.less';
const renderChangeIcon = (changeType) => {
    let label = null;
    let icon = null;
    switch (changeType) {
        case 'Added':
            label = txt('added');
            icon = _jsx(PlusOutlined, {});
            break;
        case 'Removed':
            label = txt('removed');
            icon = _jsx(MinusOutlined, {});
            break;
        case 'Modified':
            label = txt('modified');
            icon = _jsx(EditOutlined, {});
            break;
        case 'Created':
            label = txt('created');
            icon = _jsx(CheckCircleOutlined, {});
            break;
        default:
            break;
    }
    if (label === null || icon === null) {
        return null;
    }
    return (_jsx(Tooltip, { title: label, children: icon }));
};
const ChangeItem = ({ change }) => {
    if (change === null) {
        return (_jsxs("li", { className: styles.changeItem, children: [renderChangeIcon('Created'), "Created"] }));
    }
    return (_jsxs("li", { className: styles.changeItem, children: [renderChangeIcon(change.changeType), _jsx("span", { children: change.label })] }, change.key));
};
export default ChangeItem;
